import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, unref as _unref, createElementVNode as _createElementVNode } from "vue"

import { computed, inject, ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import LoginService from '@/account/login.service';
import AccountService from '@/account/account.service';
import TranslationService from '@/locale/translation.service';
import { type MenuId } from '@/venit/services/model/techpubs-cms';
import UserMenuSidebar from '@/venit/components/menu/user-menu-sidebar.vue';
import MenuUtils from '@/shared/menu/menu-utils.service';
import { useTranslationStore } from '@/stores/translation';
import { useAccountStore } from '@/stores/account';
import { useAppStateStore } from '@/stores/appState';


export default /*@__PURE__*/_defineComponent({
  __name: 'app-sidebar',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const loginService = inject<() => LoginService>('loginService')!;
const translationService = inject<() => TranslationService>('translationService')!;
const accountService = inject<() => AccountService>('accountService')!;

const translationStore = useTranslationStore();
const accountStore = useAccountStore();
const appStateStore = useAppStateStore();

const userRootMenuId = MenuUtils.userRootMenuId();
const currentUserMenuId = ref<MenuId | null>(null);

const currentLanguage = computed(() => translationStore.currentLanguage);
const authenticated = computed(() => accountStore.authenticated);
const isAdmin = computed(() => accountService().isAdmin);
const isSales = computed(() => accountService().isSales);
const isAuthor = computed(() => accountService().isAuthor);
const isManager = computed(() => accountService().isManager);
const isUser = computed(() => accountService().isUser);
const accountSwitched = computed(() => accountStore.accountSwitched);
const drawer = computed({
  get: () => appStateStore.drawer,
  set: (value: boolean) => appStateStore.setDrawer(value),
});

const logout = (): void => {
  if (accountSwitched.value) {
    loginService().exitImpersonate();
  } else {
    loginService().logout();
  }
};

const login = (): void => {
  router.push('/login').catch(() => {});
};

const onOpenMenuContent = (menuId: MenuId): void => {
  currentUserMenuId.value = menuId;
  const destPath = '/user/page/' + menuId.id;
  if (route.path != destPath) {
    router.push(destPath).catch(error => {
      if (error.name != 'NavigationDuplicated') {
        throw error;
      }
    });
  }
};

onMounted(() => {
  translationService().refreshTranslation(currentLanguage.value);
});

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    modelValue: drawer.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((drawer).value = $event)),
    width: 325
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_list, { density: "compact" }, {
        default: _withCtx(() => [
          (!authenticated.value)
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 0,
                link: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (login())),
                "prepend-icon": "mdi-send"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('sidebar.login')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          (authenticated.value)
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 1,
                link: "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (logout())),
                "prepend-icon": "mdi-logout-variant"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('sidebar.logout')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_v_divider),
      (isAdmin.value)
        ? (_openBlock(), _createBlock(_component_v_list, {
            key: 0,
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createCommentVNode(" SEARCH "),
              _createVNode(_component_v_list_item, {
                link: "",
                to: "/user/search",
                title: _ctx.$t('sidebar.user.search'),
                "append-icon": "mdi-magnify"
              }, null, 8 /* PROPS */, ["title"])
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      (isAdmin.value)
        ? (_openBlock(), _createBlock(_component_v_divider, { key: 1 }))
        : _createCommentVNode("v-if", true),
      (isAdmin.value || isSales.value || isAuthor.value || isManager.value)
        ? (_openBlock(), _createBlock(_component_v_list, {
            key: 2,
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createCommentVNode(" ORDERS "),
              (isAdmin.value || isSales.value)
                ? (_openBlock(), _createBlock(_component_v_list_group, {
                    key: 0,
                    value: "orders"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_list_item, _mergeProps(props, {
                        title: _ctx.$t('sidebar.orders.title')
                      }), null, 16 /* FULL_PROPS */, ["title"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        link: "",
                        to: "/admin/carts-management",
                        title: _ctx.$t('sidebar.orders.cartsManagement'),
                        "append-icon": "mdi-cart-outline"
                      }, null, 8 /* PROPS */, ["title"]),
                      _createVNode(_component_v_list_item, {
                        link: "",
                        to: "/admin/orders-management",
                        title: _ctx.$t('sidebar.orders.ordersManagement'),
                        "append-icon": "mdi-cart-check"
                      }, null, 8 /* PROPS */, ["title"])
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" CONTENT "),
              (isAdmin.value || isAuthor.value)
                ? (_openBlock(), _createBlock(_component_v_list_group, {
                    key: 1,
                    value: "content"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_list_item, _mergeProps(props, {
                        title: _ctx.$t('sidebar.content.title')
                      }), null, 16 /* FULL_PROPS */, ["title"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        link: "",
                        to: "/admin/resource-management",
                        title: _ctx.$t('sidebar.admin.resources'),
                        "append-icon": "mdi-semantic-web"
                      }, null, 8 /* PROPS */, ["title"]),
                      _createVNode(_component_v_list_item, {
                        link: "",
                        to: "/admin/filters-management",
                        title: _ctx.$t('sidebar.admin.filters'),
                        "append-icon": "mdi-filter"
                      }, null, 8 /* PROPS */, ["title"]),
                      _createVNode(_component_v_list_item, {
                        link: "",
                        to: "/admin/menu-management",
                        title: _ctx.$t('sidebar.admin.menu-management'),
                        "append-icon": "mdi-dots-horizontal"
                      }, null, 8 /* PROPS */, ["title"]),
                      (isAdmin.value)
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 0,
                            link: "",
                            to: "/admin/resource-properties-management",
                            title: _ctx.$t('sidebar.admin.resource-properties-management'),
                            "append-icon": "mdi-hammer-wrench"
                          }, null, 8 /* PROPS */, ["title"]))
                        : _createCommentVNode("v-if", true),
                      (isAdmin.value)
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 1,
                            link: "",
                            to: "/admin/resource-permissions-management",
                            title: _ctx.$t('sidebar.admin.resource-permissions-management'),
                            "append-icon": "mdi-account-supervisor"
                          }, null, 8 /* PROPS */, ["title"]))
                        : _createCommentVNode("v-if", true),
                      (isAdmin.value)
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 2,
                            link: "",
                            to: "/admin/products-management",
                            title: _ctx.$t('sidebar.admin.products'),
                            "append-icon": "mdi-car"
                          }, null, 8 /* PROPS */, ["title"]))
                        : _createCommentVNode("v-if", true),
                      (isAdmin.value)
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 3,
                            link: "",
                            to: "/admin/upload-file",
                            title: _ctx.$t('sidebar.admin.upload'),
                            "append-icon": "mdi-upload"
                          }, null, 8 /* PROPS */, ["title"]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" PARTS "),
              (isAdmin.value)
                ? (_openBlock(), _createBlock(_component_v_list_group, {
                    key: 2,
                    value: "parts"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_list_item, _mergeProps(props, {
                        title: _ctx.$t('sidebar.parts.title')
                      }), null, 16 /* FULL_PROPS */, ["title"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        link: "",
                        to: "/admin/parts-management",
                        title: _ctx.$t('sidebar.admin.parts'),
                        "append-icon": "mdi-hammer-wrench"
                      }, null, 8 /* PROPS */, ["title"]),
                      _createVNode(_component_v_list_item, {
                        link: "",
                        to: "/admin/parts-upload",
                        title: _ctx.$t('sidebar.admin.partsUpload'),
                        "append-icon": "mdi-upload"
                      }, null, 8 /* PROPS */, ["title"])
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" PRODUCTION "),
              (isAdmin.value)
                ? (_openBlock(), _createBlock(_component_v_list_group, {
                    key: 3,
                    value: "production"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_list_item, _mergeProps(props, {
                        title: _ctx.$t('sidebar.production.title')
                      }), null, 16 /* FULL_PROPS */, ["title"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        link: "",
                        to: "/admin/production-import",
                        title: _ctx.$t('sidebar.admin.productionImport'),
                        "append-icon": "mdi-database-import"
                      }, null, 8 /* PROPS */, ["title"]),
                      _createVNode(_component_v_list_item, {
                        link: "",
                        to: "/admin/production-units",
                        title: _ctx.$t('sidebar.admin.productionUnits'),
                        "append-icon": "mdi-car-multiple"
                      }, null, 8 /* PROPS */, ["title"])
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" USERS "),
              (isAdmin.value || isManager.value)
                ? (_openBlock(), _createBlock(_component_v_list_group, {
                    key: 4,
                    value: "users"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_list_item, _mergeProps(props, {
                        title: _ctx.$t('sidebar.users.title')
                      }), null, 16 /* FULL_PROPS */, ["title"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        link: "",
                        to: "/admin/user-management",
                        title: _ctx.$t('sidebar.admin.users'),
                        "append-icon": "mdi-account-supervisor"
                      }, null, 8 /* PROPS */, ["title"]),
                      _createVNode(_component_v_list_item, {
                        link: "",
                        to: "/admin/organizations-management",
                        title: _ctx.$t('sidebar.admin.organizations'),
                        "append-icon": "mdi-account-supervisor"
                      }, null, 8 /* PROPS */, ["title"]),
                      _createVNode(_component_v_list_item, {
                        link: "",
                        to: "/admin/user-resource-permission-groups",
                        title: _ctx.$t('sidebar.admin.user-resource-permission-groups'),
                        "append-icon": "mdi-account-group"
                      }, null, 8 /* PROPS */, ["title"])
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" EMAILS "),
              (isAdmin.value || isSales.value || isManager.value)
                ? (_openBlock(), _createBlock(_component_v_list_group, {
                    key: 5,
                    value: "emails"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_list_item, _mergeProps(props, {
                        title: _ctx.$t('sidebar.emails.title')
                      }), null, 16 /* FULL_PROPS */, ["title"])
                    ]),
                    default: _withCtx(() => [
                      (isAdmin.value || isSales.value)
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 0,
                            link: "",
                            to: "/admin/email-history",
                            title: _ctx.$t('sidebar.emails.emailHistory'),
                            "append-icon": "mdi-email-multiple-outline"
                          }, null, 8 /* PROPS */, ["title"]))
                        : _createCommentVNode("v-if", true),
                      (isAdmin.value || isManager.value)
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 1,
                            link: "",
                            to: "/admin/email-templates-management",
                            title: _ctx.$t('sidebar.emails.emailTemplates'),
                            "append-icon": "mdi-email-edit-outline"
                          }, null, 8 /* PROPS */, ["title"]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" OTHER "),
              (isAdmin.value || isManager.value || isAuthor.value)
                ? (_openBlock(), _createBlock(_component_v_list_group, {
                    key: 6,
                    value: "other"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_list_item, _mergeProps(props, {
                        title: _ctx.$t('sidebar.other.title')
                      }), null, 16 /* FULL_PROPS */, ["title"])
                    ]),
                    default: _withCtx(() => [
                      (isAdmin.value)
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 0,
                            link: "",
                            to: "/admin/import-property-mapping",
                            title: _ctx.$t('sidebar.admin.import-property-mapping'),
                            "append-icon": "mdi-swap-horizontal"
                          }, null, 8 /* PROPS */, ["title"]))
                        : _createCommentVNode("v-if", true),
                      (isAdmin.value)
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 1,
                            link: "",
                            to: "/admin/import-auto-match-config",
                            title: _ctx.$t('sidebar.admin.import-auto-match-config'),
                            "append-icon": "mdi-auto-fix"
                          }, null, 8 /* PROPS */, ["title"]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_v_divider),
      (isUser.value)
        ? (_openBlock(), _createBlock(_component_v_list, {
            key: 3,
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, {
                link: "",
                to: "/user/search",
                title: _ctx.$t('sidebar.user.search'),
                "prepend-icon": "mdi-magnify"
              }, null, 8 /* PROPS */, ["title"]),
              _createVNode(_component_v_list_item, {
                link: "",
                to: "/user/orders",
                title: _ctx.$t('sidebar.user.orders'),
                "prepend-icon": "mdi-cart-check"
              }, null, 8 /* PROPS */, ["title"])
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      (isUser.value)
        ? (_openBlock(), _createBlock(_component_v_divider, { key: 4 }))
        : _createCommentVNode("v-if", true),
      (isUser.value)
        ? (_openBlock(), _createBlock(UserMenuSidebar, {
            key: 5,
            "root-menu-id": _unref(userRootMenuId),
            onOpenMenuContent: onOpenMenuContent
          }, null, 8 /* PROPS */, ["root-menu-id"]))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_v_divider),
      _cache[3] || (_cache[3] = _createElementVNode("div", { style: {"height":"64px"} }, null, -1 /* CACHED */))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]))
}
}

})